export default "__VITE_ASSET__d922cc56__"